import { arrayOf, objectOf, maybe } from "@altostra/type-validations";
import { string, number } from "@altostra/type-validations/lib/primitives";

export const isUsersPreferenceCentersResult = objectOf({
  results: arrayOf(
    objectOf({
      name: string,
      description: maybe(string),
      type: string,
      status: string,
      lastEdited: number,
      createdBy: maybe(string),
      id: string,
      html: maybe(string),
      dndJson: maybe(string),
    })
  ),
});
